import { render } from "./BaseCard.vue?vue&type=template&id=788fdc02&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=788fdc02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-788fdc02"

export default script